import {GeneralService} from "../../../../../services/generalService";
import {DICTIONARY} from "../../../../../dictionary";
import {Component, OnInit} from "@angular/core";
import {RouteService} from "../../../../../services/routeService";
import {NotificationService} from "../../../../../services/notificationService";
import util from "util";


@Component({
	selector: 'threat-response-component',
	templateUrl: './threat-retrospect.component.html',
})
export class ThreatRetrospectComponent implements OnInit {
    constructor(private gs:GeneralService,
				private ns:NotificationService,
				private rs:RouteService) {
    }
    dic = DICTIONARY;
	config;
	isFeatureEnabled = false;
	getConfigInProcess;
	updateConfigInProcess;


	ngOnInit() {
        this.getThreatRetrospectSettings();
    };


	getThreatRetrospectSettings = () => {
        if (this.getConfigInProcess) {
            return;
        }

        this.getConfigInProcess = true;
        this.rs.getThreatRetrospectSettings().then((response) => {
			this.config = response?.retrospect;
			this.isFeatureEnabled = response?.exchange_server?.enabled || response?.gsuite_server?.enabled;
            this.getConfigInProcess = false;
        }, () => {
            this.getConfigInProcess = false;
        });
    };

	updateThreatRetrospectSettings = (action) => {
		if (!this.isFeatureEnabled) {
			const message = util.format(this.dic.ERRORS.mailboxesThreatRetrospectNoExchange,'<a target="_self" href="/' + this.dic.CONSTANTS.appStates.adminInbound + '/' + this.dic.CONSTANTS.adminPages.inbound.plan + '/' + this.dic.CONSTANTS.inboundPlanSettingsPageTabs.integrations + '"><b><i>Inbound Plan Settings</i></b></a>.');
			this.ns.showErrorMessage(message);
			this.revertToggleSwitch(action);
			return;
		}

		const data:any = {
			action
		};

		switch (action) {
			case this.dic.CONSTANTS.threatRetrospectActions.enabled:
				data.enabled = this.config.enabled;
				break;

			case this.dic.CONSTANTS.threatRetrospectActions.notify_admin:
				data.notify_admin = this.config.notify_admin;
				break;
		}

		this.updateConfigInProcess = true;

		this.rs.updateThreatRetrospectSettings(data).then((response) => {
			this.ns.showInfoMessage(DICTIONARY.MESSAGES.changedSuccessfully);
			this.updateConfigInProcess = false;
		}, () => {
			this.revertToggleSwitch(action);
			this.updateConfigInProcess = false;
		});
	}

	revertToggleSwitch = (toggleName) => {
		switch (toggleName) {
			case this.dic.CONSTANTS.threatRetrospectActions.enabled:
				this.config.enabled = !this.config.enabled;
				break;

			case this.dic.CONSTANTS.threatRetrospectActions.notify_admin:
				this.config.notify_admin = !this.config.notify_admin;
				break;
		}
	}
}
